const { produce } = require("immer");

module.exports = {
  writeIndex(state, action) {
    return produce(state, draft => {
      if (draft[action.projectUid]?.[action.licenceUid]) {
        draft[action.projectUid][action.licenceUid].index = action.index;
      } else {
        console.error(`no workspace found in store (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
      }
    });
  },

  updateElements(state, action) {
    return produce(state, draft => {
      action.elements.filter(e => ![undefined, null].includes(e)).forEach(e => {
        if (draft[action.projectUid]?.[action.licenceUid]?.data?.[action.key]) {
          draft[action.projectUid][action.licenceUid].data[action.key][e.uuid] = e
        } else {
          console.error(`no entity: '${action.key}' found in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
        }
      })
    });
  },

  deleteElements(state, action) {
    return produce(state, draft => {
      action.uids.forEach(uid => {
        if (draft[action.projectUid]?.[action.licenceUid]?.data?.[action.key]) {
          if (uid in draft[action.projectUid][action.licenceUid].data[action.key]) {
            delete draft[action.projectUid][action.licenceUid].data[action.key][uid];
          } else {
            console.error(`no ${action.key} found with uid: '${uid}' in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
          }
        } else {
          console.error(`no entity: '${action.key}' found in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
        }
      });
    });
  },

  updateAllElements(state, action) {
    return produce(state, draft => {
      for (let { type, elements } of action.elements) {
        for (let e of elements) {
          if (![undefined, null].includes(e)) {
            if (draft[action.projectUid]?.[action.licenceUid]?.data?.[type]) {
              draft[action.projectUid][action.licenceUid].data[type][e.uuid] = e
            } else {
              console.error(`no entity: '${type}' found in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
            }
          }
        }
      }
    });
  },

  deleteAllElements(state, action) {
    return produce(state, draft => {
      Object.keys(action.toClean).forEach(type => action.toClean[type].forEach(uid => {
        if (draft[action.projectUid]?.[action.licenceUid]?.data?.[type]) {
          if (uid in draft[action.projectUid][action.licenceUid].data[type]) {
            delete draft[action.projectUid][action.licenceUid].data[type][uid];
          } else {
            console.error(`no ${type} found with uid: '${uid}' in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
          }
        } else {
          console.error(`no entity: '${type}' found in workspace (projectUid: ${action.projectUid}, licenceUid: ${action.licenceUid})`)
        }
      }))
    });
  },

  requestFailed(state, action) {
    return produce(state, draft => {
      if (draft[action.projectUid][action.licenceUid].failed) {
        draft[action.projectUid][action.licenceUid].failed.push(action.params)
      }
    })
  },

  retrySuccess(state, action) {
    return produce(state, draft => {
      if (draft[action.projectUid][action.licenceUid].failed) {
        draft[action.projectUid][action.licenceUid].failed = draft[action.projectUid][action.licenceUid].failed.filter(f => {
          return f.timestamp !== action.params.timestamp
        })
      }
    })
  },

  retryInvalid(state, action) {
    return produce(state, draft => {
      if (draft[action.projectUid][action.licenceUid].failed) {
        draft[action.projectUid][action.licenceUid].failed = draft[action.projectUid][action.licenceUid].failed.filter(f => {
          return f.timestamp === action.params.timestamp
        })
      }
    })
  },

  subReducers(state, action, reducers) {
    return produce(state, draft => {
      const draftWs = draft[action.projectUid] && draft[action.projectUid][action.licenceUid];
      if (draftWs) {
        const stateWs = state[action.projectUid] && state[action.projectUid][action.licenceUid];
        if ("data" in stateWs && reducers.data) draftWs.data = reducers.data(stateWs.data, action, state);
        if ("local" in stateWs && reducers.local) draftWs.local = reducers.local(stateWs.local, action, state);
        if ("shared" in stateWs && reducers.shared) draftWs.shared = reducers.shared(stateWs.shared, action, state);
        // if("setting" in ws && reducers.setting) Object.assign(ws.setting, reducers.setting(stateWs.setting, action, state));
      }
    })
  },

  streamProgress(state, action) {
    return produce(state, draft => {
      let streamProgress = action.licenceUid ? draft[action.projectUid]?.[action.licenceUid]?.streamProgress : draft.streamProgress
      if (streamProgress) {
        streamProgress[action.streamId] = {
          packetId: action.packetId,
          chunkNum: action.chunkNum,
          downloadedBytes: action.downloadedBytes,
          streamedBytes: action.streamedBytes
        }
      }
    })
  },

  clearStreamProgress(state, action) {
    return produce(state, draft => {
      let streamProgress = action.licenceUid ? draft[action.projectUid]?.[action.licenceUid]?.streamProgress : draft.streamProgress
      if (streamProgress) {
        for (const streamId of action.streamIds) {
          if (streamId in streamProgress) {
            delete streamProgress[streamId]
          }
        }
      }
    })
  }
}